import React from "react";
import { AltimeterRow } from "components/AltimSet";
import type { WindowPosition } from "@poscon/shared-frontend";

export const AltimeterTearoff = ({ airport, pos }: { airport: string; pos: WindowPosition }) => {
  return <AltimeterRow stationCode={airport} x={pos.x} y={pos.y} asTearoff />;
};
